// src/components/profile/UserProfile.jsx
// Consolidated: this route now renders the SAME shared Overview used on the
// dashboard and the home page. One design, one place — no separate profile UI.
import React from 'react';
import OverviewPanel from '../dashboard/OverviewPanel';

const UserProfile = ({ user }) => {
  return (
    <section className="section" id="profile" style={{ paddingTop: '5.5rem', paddingBottom: '3rem' }}>
      <div className="container">
        <OverviewPanel user={user} />
      </div>
    </section>
  );
};

export default UserProfile;